import CheckroomIcon from "@mui/icons-material/Checkroom";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import LocalActivityIcon from "@mui/icons-material/LocalActivity";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";

export const EVENT_TYPES = {
	1: {
		id: 1,
		key: "comida",
		label: "Menjar",
		labelPlural: "Menjars",
		className: "events-type-food",
		icon: RestaurantMenuIcon,
	},
	2: {
		id: 2,
		key: "limpieza",
		label: "Neteja",
		labelPlural: "Neteja",
		className: "events-type-cleaning",
		icon: CleaningServicesIcon,
	},
	3: {
		id: 3,
		key: "actividad",
		label: "Activitat",
		labelPlural: "Activitats",
		className: "events-type-activity",
		icon: LocalActivityIcon,
	},
	4: {
		id: 4,
		key: "ropa",
		label: "Roba",
		labelPlural: "Roba",
		className: "events-type-clothes",
		icon: CheckroomIcon,
	},
};

export const EVENT_TYPE_LIST = Object.values(EVENT_TYPES);

export const getEventType = (id) => EVENT_TYPES[Number(id)] || EVENT_TYPES[3];

export const invitadosValor = (invitados, clave) => (
	invitados?.[clave]
	|| invitados?.[clave.replace("nino", "niño")]
	|| invitados?.[clave.replace("nino", "niÃ±o")]
	|| invitados?.[clave.replace("nino", "niÃƒÂ±o")]
	|| 0
);

export const contarAsistentes = (evento) => (
	(evento.asistentes || []).reduce((acc, asistente) => {
		if (Array.isArray(asistente.tickets) && asistente.tickets.length > 0) {
			return acc + (Number(asistente.miembro_asiste ?? 1) === 1 ? 1 : 0) + asistente.tickets.reduce((sum, ticket) => sum + Number(ticket.cantidad || 0), 0);
		}

		const invitados = asistente.invitados || {};
		return acc + (Number(asistente.miembro_asiste ?? 1) === 1 ? 1 : 0) + invitadosValor(invitados, "invitados") + invitadosValor(invitados, "invitados_nino1") + invitadosValor(invitados, "invitados_nino2");
	}, 0)
);

export const getResumenCategoriasTickets = (evento) => {
	const resumen = new Map();
	(evento?.asistentes || []).forEach((asistente) => {
		if (Array.isArray(asistente.tickets) && asistente.tickets.length > 0) {
			asistente.tickets.forEach((ticket) => {
				const id = ticket.id_categoria_ticket ?? `sin-categoria-${ticket.id_tipo_ticket}`;
				const nombre = ticket.categoria_nombre || 'Sense categoria';
				const actual = resumen.get(id) || { id, nombre, cantidad: 0 };
				actual.cantidad += Number(ticket.cantidad || 0);
				resumen.set(id, actual);
			});
		}
	});
	return Array.from(resumen.values());
};

export const formatoFecha = (fecha) => {
	if (!fecha) return "Sense data";

	return new Date(`${fecha}T00:00:00`).toLocaleDateString("ca-ES", {
		weekday: "long",
		day: "2-digit",
		month: "long",
	});
};

export const formatoFechaCorta = (fecha) => {
	if (!fecha) return "Sense data";

	return new Date(`${fecha}T00:00:00`).toLocaleDateString("ca-ES", {
		day: "2-digit",
		month: "short",
	});
};

export const formatoHorarioEvento = (evento) => {
	const inicio = evento?.hora_inicio || "--:--";
	const fin = evento?.hora_final || "--:--";

	return `El ${formatoFechaCorta(evento?.fecha)} de ${inicio} a ${fin}`;
};

export const getOptionId = (option) => Number(option?.id_usuario ?? option?.id ?? option?.value ?? 0);

export const getEncargadosEvento = (evento, opTrabajadores = []) => {
	const ids = Array.isArray(evento?.id_usuarios_encargados)
		? evento.id_usuarios_encargados.map(Number).filter(Boolean)
		: [];

	if (ids.length === 0 && evento?.id_usuario_encargado) {
		ids.push(Number(evento.id_usuario_encargado));
	}

	const desdeEvento = Array.isArray(evento?.encargados)
		? evento.encargados.map((item) => ({
			id_usuario: getOptionId(item),
			nombre: item.nombre || item.label || "",
		})).filter((item) => item.id_usuario)
		: [];

	const encargados = ids.map((id) => {
		const directo = desdeEvento.find((item) => item.id_usuario === id);
		const opcion = opTrabajadores.find((item) => getOptionId(item) === id);

		return {
			id_usuario: id,
			nombre: directo?.nombre || opcion?.nombre || opcion?.Nombre || opcion?.label || "Sense assignar",
		};
	});

	return encargados.length > 0 ? encargados : desdeEvento;
};

export const getOpcionesEncargadosEvento = (evento, opTrabajadores = []) => {
	const encargados = getEncargadosEvento(evento, opTrabajadores);

	return encargados
		.map((encargado) => (
			opTrabajadores.find((option) => getOptionId(option) === encargado.id_usuario)
			|| {
				value: encargado.id_usuario,
				label: encargado.nombre,
				nombre: encargado.nombre,
			}
		))
		.filter(Boolean);
};

export const getTextoEncargadosEvento = (evento, opTrabajadores = []) => {
	const encargados = getEncargadosEvento(evento, opTrabajadores);
	const nombres = encargados.map((item) => item.nombre).filter(Boolean);

	if (nombres.length === 0) {
		return {
			label: "Encarregat",
			texto: "Sense assignar",
		};
	}

	return {
		label: nombres.length > 1 ? "Encarregats" : "Encarregat",
		texto: nombres.join(", "),
	};
};

export const formatoEuroEvento = (valor) => Number(valor || 0).toLocaleString("es-ES", {
	style: "currency",
	currency: "EUR",
});

export const getPreciosTicketsMap = (evento) => {
	const map = {};

	if (evento?.precios_tickets_map && typeof evento.precios_tickets_map === "object") {
		Object.entries(evento.precios_tickets_map).forEach(([id, precio]) => {
			map[Number(id)] = Number(precio || 0);
		});
	}

	if (Array.isArray(evento?.precios_tickets)) {
		evento.precios_tickets.forEach((item) => {
			map[Number(item.id_tipo_ticket)] = Number(item.precio || 0);
		});
	}

	return map;
};

export const getPrecioTicketEvento = (evento, tipoTicket) => {
	if (Number(evento?.id_tipo_evento) !== 1) {
		return 0;
	}

	if (Number(tipoTicket?.paga) !== 1) {
		return 0;
	}

	const precios = getPreciosTicketsMap(evento);
	const idTipoTicket = Number(tipoTicket?.id);

	if (Object.prototype.hasOwnProperty.call(precios, idTipoTicket)) {
		return Number(precios[idTipoTicket] || 0);
	}

	return Number(evento?.precio_persona || 0);
};

export const getResumenPreciosEvento = (evento) => {
	if (Number(evento?.id_tipo_evento) !== 1) {
		return "";
	}

	const precios = Object.values(getPreciosTicketsMap(evento)).map(Number).filter((precio) => precio > 0);

	if (precios.length === 0 && Number(evento?.precio_persona || 0) > 0) {
		return formatoEuroEvento(evento.precio_persona);
	}

	if (precios.length === 0) {
		return "";
	}

	const unicos = [...new Set(precios)];
	if (unicos.length === 1) {
		return formatoEuroEvento(unicos[0]);
	}

	return `Des de ${formatoEuroEvento(Math.min(...precios))}`;
};
